import { render, staticRenderFns } from "./contactDetail.vue?vue&type=template&id=bcf45702&"
import script from "./contactDetail.vue?vue&type=script&lang=js&"
export * from "./contactDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports